import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ShopComponent } from './pages/shop/shop.component';
import { CheckoutComponent } from './pages/shop/checkout/checkout.component';
import { authGuard } from './shared/guards/auth.guard';
import { CourseAccessGuard } from './shared/guards/course-access.guard';
import { maintenanceGuard } from './shared/guards/maintenance.guard';

export const routes: Routes = [
  {
    path: 'maintenance',
    loadComponent: () => import('./pages/maintenance/maintenance.component').then(m => m.MaintenanceComponent)
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [maintenanceGuard],
    data: { scrollPositionRestoration: 'top' }
  },
  {
    path: 'cookies',
    loadComponent: () => import('./pages/cookies/cookies.component').then(m => m.CookiesComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard],
    data: { ssr: false },
    children: [
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
        data: { ssr: false }
      },
      {
        path: 'courses',
        data: { ssr: false },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/courses/courses.component').then(m => m.CoursesComponent),
            data: { ssr: false }
          },
          {
            path: ':id',
            canActivate: [CourseAccessGuard],
            data: { ssr: false },
            children: [
              {
                path: '',
                loadComponent: () => import('./pages/course-detail/course-detail.component').then(m => m.CourseDetailComponent),
                data: { ssr: false }
              },
              {
                path: 'modules/:moduleId',
                canActivate: [CourseAccessGuard],
                data: { ssr: false },
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./pages/course-detail/module-detail/module-detail.component').then(m => m.ModuleDetailComponent),
                    data: { ssr: false }
                  },
                  {
                    path: 'lessons/:lessonId',
                    loadComponent: () => import('./pages/course-detail/lesson-detail/lesson-detail.component').then(m => m.LessonDetailComponent),
                    data: { ssr: false }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'support',
        loadComponent: () => import('./pages/support/support.component').then(m => m.SupportComponent),
        data: { ssr: false }
      },
      {
        path: 'sales-partner',
        loadComponent: () => import('./pages/sales-partner-dashboard/sales-partner-dashboard.component').then(m => m.SalesPartnerDashboardComponent),
        data: { ssr: false }
      },
      {
        path: 'shop',
        loadComponent: () => import('./pages/shop/shop.component').then(m => m.ShopComponent),
        title: 'Shop'
      }
    ]
  },
  {
    path: 'shop',
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        component: ShopComponent
      },
      {
        path: 'checkout',
        component: CheckoutComponent
      }
    ]
  },
  {
    path: 'success',
    loadComponent: () => import('./pages/shop/success/success.component').then(m => m.SuccessComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'activate',
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/activate/activate.component').then(m => m.ActivateComponent)
      },
      {
        path: 'success',
        loadComponent: () => import('./pages/activate/activate-success.component').then(m => m.ActivateSuccessComponent)
      }
    ]
  },
  {
    path: 'produkte',
    loadComponent: () => import('./pages/produkte/produkte.component').then(m => m.ProdukteComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'ueber-uns',
    loadComponent: () => import('./pages/ueber-uns/ueber-uns.component').then(m => m.UeberUnsComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'blog',
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/blog/blog.component').then(m => m.BlogComponent),
        data: {
          ssr: false
        }
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/blog/blog-detail/blog-detail.component').then(m => m.BlogDetailComponent),
        data: {
          ssr: false
        }
      }
    ]
  },
  {
    path: 'events',
    loadComponent: () => import('./pages/events/events.component').then(m => m.EventsComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'agb',
    loadComponent: () => import('./pages/agb/agb.component').then(m => m.AgbComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'widerruf',
    loadComponent: () => import('./pages/widerruf/widerruf.component').then(m => m.WiderrufComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'disclaimer',
    loadComponent: () => import('./pages/disclaimer/disclaimer.component').then(m => m.DisclaimerComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'impressum',
    loadComponent: () => import('./pages/impressum/impressum.component').then(m => m.ImpressumComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./pages/datenschutz/datenschutz.component').then(m => m.DatenschutzComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'interviews',
    loadComponent: () => import('./pages/interviews/interviews.component').then(m => m.InterviewsComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'produkte/:id',
    loadComponent: () => import('./pages/product-detail/product-detail.component')
      .then(m => m.ProductDetailComponent),
    canActivate: [maintenanceGuard],
    data: {
      ssr: false
    }
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'kontakt',
    loadComponent: () => import('./pages/kontakt/kontakt.component').then(m => m.KontaktComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'partner-agreement',
    loadComponent: () => import('./pages/legal/partner-agreement/partner-agreement.component').then(m => m.PartnerAgreementComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'geld-zurueck-garantie',
    loadComponent: () => import('./pages/money-back-guarantee/money-back-guarantee.component').then(m => m.MoneyBackGuaranteeComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'merch',
    loadComponent: () => import('./pages/merch/merch.component').then(m => m.MerchComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'helpcenter',
    loadComponent: () => import('./pages/helpcenter/helpcenter.component').then(m => m.HelpcenterComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'helpcenter/category/:id',
    loadComponent: () => import('./pages/helpcenter/category/category.component').then(m => m.HelpcenterCategoryComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'helpcenter/category/:categoryId/article/:articleId',
    loadComponent: () => import('./pages/helpcenter/article/article.component').then(m => m.HelpcenterArticleComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'vertriebspartner-bewerbung',
    loadComponent: () => import('./pages/sales-partner-application/sales-partner-application.component').then(m => m.SalesPartnerApplicationComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'bewerben',
    loadComponent: () => import('./pages/funnel/funnel-wizard.component').then(m => m.FunnelWizardComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: '**',
    redirectTo: '/maintenance'
  }
];

export const routerConfig = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 0]
};
